import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../Context/GlobalStateContext";
import MainTopFilters from "../App/MainTopFilters";
function Home() {
  const [ShowGateway, SetShowGateway] = useState(false);
  const [ShowGatewaychild, SetShowGatewaychild] = useState(true);
  const ShowHideGateway = () => {
    SetShowGateway(!ShowGateway);
  };
  const ShowHideGatewaychild = () => {
    SetShowGatewaychild(!ShowGatewaychild);
  };
  const ExpandAll = () => {
    SetShowGateway(true);
    SetShowGatewaychild(true);
  };

  const navigate = useNavigate();
  const globalState = useGlobalState();
  useEffect(() => {
    // navigate("/apoactivity");
  }, []);
  function MainTopFiltersCallBack(p_selectedId: any) {}

  return (
    <div className="page--data">
      {/* <div className="flex-container">
        <select className="select-md">
          <option>2024/2025 ibb program - Q1</option>
        </select>
        <select className="select-lg">
          <option>Al Mahmoudia Vehicle Trading Co. Ltd [Jordan]</option>
        </select>
        <span></span>
      </div>
      <div className="flex-container">
        <div className="re-earn">
          <span className="re-val1">Criteria %</span>
          <span className="re-val2">5%</span>
        </div>
        <div className="pot-fp">
          <div className="re-earn">
            <span className="re-val1">
              <span>POT</span>{" "}
              <img src="images/eye.svg" width="20px" height="14px" />
            </span>
            <span className="re-val2">$5,000,000</span>
          </div>
          <div className="pot-per">100%</div>
          <div className="re-earn">
            <span className="re-val1">Final Payout</span>
            <span className="re-val2">$2,000,000</span>
          </div>
        </div>
        <div className="re-earn g-box">
          <span className="re-val1">Status</span>
          <span className="re-val2">Approved</span>
        </div>
      </div>
      <div className="expand-all">
        <a onClick={ExpandAll}>Expand All</a>
      </div>
      <div className="gate-ways-tab">
        <div className="tab-title-g">Gateways</div>
        <div className="tab-g-boxes">
          <span className="b-g"></span>
          <span className="b-r"></span>
          <span className="b-g"></span>
          <span className="b-g"></span>
          <span className="b-r"></span>
        </div>
        <div className="tab-g-exceptions">
          <div className="excp-left">
            <div className="excp-1">
              <img src="images/excp.svg" width="24px" height="24px" />
              <span>Exceptions</span>
            </div>
            <div className="excp-2">
              <span className="e-y">2</span>
              <span className="e-g"></span>
              <span className="e-r"></span>
            </div>
          </div>
          <a onClick={ShowHideGateway}>
            {ShowGateway && (
              <img
                src="images/expand.svg"
                className="rotate-180"
                width="24px"
                height="24px"
              />
            )}
            {!ShowGateway && (
              <img src="images/expand.svg" width="24px" height="24px" />
            )}
          </a>
        </div>
      </div>
      {ShowGateway && <div className="g-accord">GateWay Open Expanded</div>}
      <div className="lock-icon">
        <img src="images/lock-circle.svg" width="60px" height="60px" />
      </div>
      <div className="gate-ways-tab gate-ways-inner">
        <div className="tab-title-g tab-title-gsm">1. CPP & SPNV</div>
        <div className="val-stat-main">
          <div className="val-stat vs-c1">
            <div className="val-ex">
              <span className="v-c-1">Value:</span>
              <span className="v-c-2">1%</span>
            </div>
            <div className="val-ex">
              <span className="v-c-1">Status:</span>
              <span className="v-c-3 approved">Approved</span>
            </div>
          </div>
          <div className="val-stat vs-c2">
            <div className="val-ex">
              <span className="v-c-1">POT:</span>
              <span className="v-c-4">$1,000,000</span>
            </div>
            <div className="val-ex">
              <span className="v-c-1">Final Payout:</span>
              <span className="v-c-5">$1,000,000</span>
            </div>
          </div>
        </div>
        <div className="tab-g-exceptions">
          <div className="excp-left">
            <div className="excp-1">
              <img src="images/excp.svg" width="24px" height="24px" />
              <span>Exceptions</span>
            </div>
            <div className="excp-2">
              <span className="e-y"></span>
              <span className="e-g">3</span>
              <span className="e-r"></span>
            </div>
          </div>
          <a onClick={ShowHideGatewaychild}>
            {ShowGatewaychild && (
              <img
                src="images/expand.svg"
                className="rotate-180"
                width="24px"
                height="24px"
              />
            )}
            {!ShowGatewaychild && (
              <img src="images/expand.svg" width="24px" height="24px" />
            )}
          </a>
        </div>
      </div>
      {ShowGatewaychild && (
        <div className="g-accord">GateWay child Open Expanded</div>
      )} */}
      <div className="flex-container">
        <div className="flex-items flex-33">
          <MainTopFilters
            ScreenID={-3000}
            MainTopFiltersCallBack={MainTopFiltersCallBack}
          />
        </div>
      </div>
      <div className="section-table scroll-table activity-table">
        <table className="part-head trend-table action-child">
          <thead>
            <tr>
              <th>Importer</th>
              <th>Status</th>
              <th>Importer Action</th>
              <th>MENA Action</th>
              <th>Global Action</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Al Mahmoudia Vehicle Trading Co. Ltd [Jordan]</td>
              <td className="text-left">Completed</td>
              <td className="text-left">Scorecard Viewed</td>
              <td className="text-left">Approved</td>
              <td className="text-left">Not Approved</td>
              <td>
                <div className="flex-items btn-grid-flex">
                  <a className="btn-grid" title="View">
                    <img src="/images/view.svg" width="14px" height="14px" />
                  </a>
                </div>
              </td>
            </tr>

            <tr>
              <td>Al Mahmoudia Vehicle Trading Co. Ltd [Jordan]</td>
              <td className="text-left">Completed</td>
              <td className="text-left">Scorecard Viewed</td>
              <td className="text-left">Approved</td>
              <td className="text-left">Not Approved</td>
              <td>
                <div className="flex-items btn-grid-flex">
                  <a className="btn-grid" title="View">
                    <img src="/images/view.svg" width="14px" height="14px" />
                  </a>
                </div>
              </td>
            </tr>

            <tr>
              <td>Al Mahmoudia Vehicle Trading Co. Ltd [Jordan]</td>
              <td className="text-left">Completed</td>
              <td className="text-left">Scorecard Viewed</td>
              <td className="text-left">Approved</td>
              <td className="text-left">Not Approved</td>
              <td>
                <div className="flex-items btn-grid-flex">
                  <a className="btn-grid" title="View">
                    <img src="/images/view.svg" width="14px" height="14px" />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Home;
